const showFilters = {
  partos: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: false,
    lotCodigo: true,
    catCodigo: true,
    statusCria: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  nascimentos: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: true,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: false, 
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  prenhez: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: false,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: false,
    considerarDescartados: true,
    considerarApenasNoFiltro: true,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  prenhas: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: false,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: true,
    genericStatus: false
  },
  previsao_desmama: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: true,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: true,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  desmames_ocorridos: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: true,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: true,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: true,
    tipoPrenhez: false,
    genericStatus: false
  },
  listar_protocolos: {
    data: true,
    espCodigo: false,
    racCodigo: false,
    sexo: false,
    lotCodigo: false,
    catCodigo: false,
    statusCria: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: true
  },
  desmamados_por_semen: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: true,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: true,
    tipoPrenhez: false,
    genericStatus: false
  },
  general_overview: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    catCodigo: true,
    lotCodigo: true,
    statusCria: true,
    sexo: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  listar_usuarios: {
    data: false,
    espCodigo: false,
    racCodigo: false,
    sexo: false,
    lotCodigo: false,
    catCodigo: false,
    statusCria: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: true
  },
  curva_abc: {
    data: true,
    espCodigo: true,
    racCodigo: false,
    sexo: false,
    lotCodigo: false,
    catCodigo: false,
    statusCria: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  perda_parto: {
    data: true,
    espCodigo: true,
    racCodigo: true,
    sexo: true,
    lotCodigo: true,
    catCodigo: true,
    statusCria: true,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: false
  },
  listar_novidades: {
    data: false,
    espCodigo: false,
    racCodigo: false,
    sexo: false,
    lotCodigo: false,
    catCodigo: false,
    statusCria: false,
    tipoBusca: false,
    considerarDescartados: false,
    considerarApenasNoFiltro: false,
    ageInMonthCombo: false,
    tipoPrenhez: false,
    genericStatus: true
  },
}

const filterItems = (translations: any) => ({
  tipoBusca: {
    previsao_desmame: [{value: translations["lbl.react.data.nascimento"], valueKey: "0"}, {value: translations["lbl.react.data.previsao"], valueKey: "1"}],
    desmames_ocorridos: [{value: translations["lbl.react.data.nascimento"], valueKey: "0"}, {value: translations["lbl.react.data.de.desmame"], valueKey: "1"}],
    perda_parto: [{value: translations["lbl.react.data.cobertura"], valueKey: "1"}, {value: translations["lbl.react.data.parto"], valueKey: "0"}]
  },
  genericStatus: [
    {
      tabName: 'listar_protocolos',
      placeholder: 'Status',
      values: [{value: translations["lbl.react.protocolo.ativo"], valueKey: "1"}, {value: translations["lbl.react.protocolo.inativo"], valueKey: "0"}]
    },
    {
      tabName: 'listar_usuarios',
      placeholder: translations["lbl.react.todos"],
      values: [{value: translations["lbl.react.usuario.multiacesso"], valueKey: "true"}, {value: translations["lbl.react.regular"], valueKey: "false"}]
    }
  ]
})

export { showFilters, filterItems }
